var User = require('user');


var Member = User.extend({
    lastSpoke: null,
    lastHighlighted: null,
    initialize: function (data, options) {
        this.session = options.session;
        this.connection = options.connection;
        this.channel = options.channel;
        this.buffer = options.channel || options.buffer;
    },
    setLastSpoke: function (lastSpoke) {
        if (!this.lastSpoke || lastSpoke > this.lastSpoke) {
            this.lastSpoke = lastSpoke;
        }
    },
    setLastHighlighted: function (lastHighlighted) {
        if (!this.lastHighlighted || lastHighlighted > this.lastHighlighted) {
            this.lastHighlighted = lastHighlighted;
        }
    },
    getLastSpoke: function () {
        if (this.isIgnored()) {
            return 0;
        }
        return this.lastSpoke;
    },
    getLastHighlighted: function () {
        if (this.isIgnored()) {
            return 0;
        }
        return this.lastHighlighted;
    }
});


module.exports = Member;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/member.js
// module id = abDD
// module chunks = 1